module.exports = __webpack_public_path__ + "img/f4.7664ead6.jpg";